<gc-branding [branding]="branding"></gc-branding>
<yc-app-shell
  [sidebarLinks]="sidebarLinks$ | async"
  [supportLinks]="supportLinks$ | async"
  [sidebarClosed]="isBBGM ? true : (sidebarClosed$ | async)"
  [logoLocation]="logoLocation ?
    (logoLocation | gcAddStaticResourceSAS) :
    './assets/img/placeholders/grants-icon-placeholde-dark.svg'"
  [productName]="'YourCause - GrantsConnect'"
  [simpleProductName]="'GrantsConnect'"
  [accountName]="accountName"
  [initials]="initials"
  [privacyPolicyLink]="privacyPolicyLink"
  [termsAndConditionsLink]="termsAndConditionsLink"
  [banners]="banners$ | async"
  [initialsBackground]="branding?.brandPrimary"
  [accountRole]="accountRole"
  [footerState]="footerState$ | async"
  [footerAction]="footerAction$ | async"
  [footerCancelAction]="footerCancelAction$ | async"
  [footerSecondaryAction]="footerSecondaryAction$ | async"
  [footerTertiaryAction]="footerTertiaryAction$ | async"
  [footerQuaternaryAction]="footerQuaternaryAction$ | async"
  [footerActionDisabled]="footerActionDisabled$ | async"
  [footerSecondaryDisabled]="footerSecondaryDisabled$ | async"
  [footerTertiaryDisabled]="footerTertiaryDisabled$ | async"
  [footerQuaternaryDisabled]="footerQuaternaryDisabled$ | async"
  [footerActionLabel]="footerActionLabel$ | async"
  [footerCancelLabel]="footerCancelLabel$ | async"
  [footerSecondaryLabel]="footerSecondaryLabel$ | async"
  [footerTertiaryLabel]="footerTertiaryLabel$ | async"
  [footerQuaternaryLabel]="footerQuaternaryLabel$ | async"
  [footerInfoText]="footerInfoText$ | async"
  [footerInfoIcon]="footerInfoIcon$ | async"
  [footerInfoTooltip]="footerInfoTooltip$ | async"
  [showHeaderButtons]="showHeaderButtons$ | async"
  [copyrightText]="copyrightText"
  [autoSignoutVisible]="showTimeout$ | async"
  [countDownTime]="timeRemaining$ | async"
  [editAccountLink]="'/management/my-account'"
  [commPreferencesLink]="'/management/communication-preferences'"
  [manageFiltersLink]="manageFiltersLink"
  [hideSidebar]="isBBGM"
  [hideBreadcrumbs]="isBBGM"
  (onKeepMeSignedIn)="keepMeSignedIn()"
  (onSignOutClick)="onSignOutClick()"
  (onSidebarToggle)="handleSidebarToggle()">
  <router-outlet></router-outlet>
</yc-app-shell>
